<ng-container [formGroup]="deliverableForm">
    <h3 class="form-header" mat-dialog-title i18n="@@ReviewToolStatus" t="ReviewToolStatus"
        >Review Tool Status</h3
    >

    <div class="grid">
        <div class="row">
            <tsl-form-field fxFlex="1 1 100%">
                <tsl-label>
                    <span i18n="@@OverrideCommentDialogText1" t="OverrideCommentDialogText1"
                        >There is a mismatch between the selected tool status and the demand of the parts added, please
                        review the following description for the Tool status to select the appropriate option.
                        Otherwise, please add a comment to justify the selected option.</span
                    >
                    <br />
                    <br />
                    <span i18n="@@OverrideCommentDialogText2" t="OverrideCommentDialogText2">
                        Select the appropriate tool status as:
                    </span>
                    <br />
                    <span i18n="@@OverrideCommentDialogText3" t="OverrideCommentDialogText3">
                        - If any of the added parts have 'Production' demand status - choose Active
                    </span>
                    <br />
                    <span i18n="@@OverrideCommentDialogText4" t="OverrideCommentDialogText4">
                        - If any of the added parts have 'Service' demand status - choose Service
                    </span>
                    <br />
                    <span i18n="@@OverrideCommentDialogText5" t="OverrideCommentDialogText5">
                        - If any of the added parts have 'Future' demand status - choose Future</span
                    >
                    <br />
                    <span i18n="@@OverrideCommentDialogText6" t="OverrideCommentDialogText6">
                        - else choose Not Active (or Future if tool will soon be in use)</span
                    >
                    <br />
                </tsl-label>

                <textarea tslInput fullwidth placeholder="Comment" tPlaceholder="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" i18n-placeholder="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" formControlName="overrideComment"></textarea>
            </tsl-form-field>
        </div>
    </div>

    <div class="right">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button filled color="blue" size="small" (click)="onSave()" i18n="@@Save" t="Save"
            >Save</button
        >
    </div>
</ng-container>
